import { AxiosInstance } from 'axios';
import { UserGroupSchema } from '../../../../models/@admin/roleschema';
import { axiosFactory } from '../../../client';
import * as ROUTES from './routes';
import { SearchParamSchema } from '../../../../models/SearchParamSchema';
import { UserGroupResponseSchema } from './responseSchemas';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/user/api`;
const timeout = 5000;

export const userGroupClient = axiosFactory(baseURL, timeout);

export const userGroupTestClient = (userGroupClient as unknown) as AxiosInstance;

/** get user roles by id
 * */
export const getUserGroupById = (id: number) =>
  userGroupClient.get<UserGroupSchema>(`${ROUTES.GET_USER_GROUP_BY_ID}/${id}`);

/** to search user group by name
 * */
export const getSearchUserGroup = (searchTerms: SearchParamSchema) =>
  userGroupClient.get<UserGroupResponseSchema>(
    `${ROUTES.GET_SEARCH_USER_GROUP}?q=${searchTerms.keywords}&page=${searchTerms.page}&size=${searchTerms.size}`
  );

/** to delete user group
 * */
export const deleteUserGroup = (csrfToken: string, id: number) =>
  userGroupClient.delete<any>(csrfToken, `${ROUTES.DELETE_USER_GROUP}/${id}`);

/** to create new user group
 */
export const postCreateUserGroup = (csrfToken: string, payload: UserGroupSchema) =>
  userGroupClient.post<any>(csrfToken, `${ROUTES.POST_USER_GROUP}`, payload);

/** to update User Group
 * */
export const putUpdateUserGroup = (csrfToken: string, payload: UserGroupSchema) =>
  userGroupClient.put(csrfToken, `${ROUTES.PUT_USER_GROUP}/${payload.id}`, payload);
